import React from 'react';
import { connect } from 'react-redux';

import PromoPopupButton from 'components/no-auth/popup/PromoPopupButton';
import PromoSimplePopup from 'components/no-auth/popup/PromoSimplePopup';

import { toggleChat } from 'actions/chatAction';

import { HELP } from 'constants/UrlConstants';

import { getLangCountryPrefix } from 'helpers/utils';

import { useApp, useLanguage, usePageMessages } from 'hooks/selectors';

const PromoSupportPopup = ({ popupRef, ...props }) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { morePopupFaqTitle, morePopupChatTitle } = usePageMessages();
    const helpLink = `${getLangCountryPrefix(lang, country)}${HELP}`;

    return (
        <PromoSimplePopup withoutBorder popupRef={popupRef}>
            <PromoPopupButton
                href={helpLink}
                iconName="info-rounded"
                text={morePopupFaqTitle}
                onClick={() => {
                    popupRef.current?.close();
                }}
            />
            <PromoPopupButton
                iconName="message-bubble"
                text={morePopupChatTitle}
                onClick={(e) => {
                    e.preventDefault();
                    popupRef.current?.close();
                    props.toggleChat(true);
                }}
            />
        </PromoSimplePopup>
    );
};

export default connect(null, { toggleChat })(PromoSupportPopup);
